module.exports = __webpack_public_path__ + "img/lightbulb.35f7812d.svg";